<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="center-home">
      <p class="title_">Rateio do mês vigente</p>
      <div class="table-teste" v-if="openDataTable.length > 0">
        <el-table
          :data="openDataTable"
          style=""
          :header-cell-style="{ color: '#333' }"
        >
          <el-table-column label="Mês" width="100">
            <template slot-scope="scope">
              <span>{{ dayjs(scope.row.period).format("MM/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Situação" width="300">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === constants.status.pending
                  ? "Aguardando rateios das filiais"
                  : scope.row.status === constants.status.opened
                  ? "Aberto"
                  : "Aguardando importação"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ações" width="150">
            <template slot-scope="scope" style="display: flex">
              <el-popover
                placement="top"
                width="350"
                v-model="scope.row.popVisible"
                :ref="'popover' + scope.$index"
              >
                <div class="confirm-items">
                  <div>
                    <b-icon
                      style="
                        margin-left: 10px;
                        margin-right: 10px;
                        color: #e87305;
                      "
                      class="icon-beaut"
                      icon="info-circle-fill"
                      font-scale="1"
                    ></b-icon>
                  </div>
                  <div>
                    <span style="word-break: break-word"
                      >Remover rateios do período
                      <b>{{ dayjs(scope.row.period).format("MM/YYYY") }}</b
                      >?</span
                    >
                    <p
                      style="
                        word-break: break-word;
                        margin-top: 10px;
                        font-size: 12px;
                      "
                    >
                      Após a remoção não será possível restaurar os rateios.
                    </p>
                  </div>
                </div>

                <div style="text-align: right; margin: 0; margin-top: 5px">
                  <el-button
                    style="background: #eaeaea; color: #515151"
                    type="text"
                    :disabled="isLoadingBtnRemove"
                    @click="scope.row.popVisible = false"
                    >cancelar</el-button
                  >
                  <el-button
                    :loading="isLoadingBtnRemove"
                    @click="handleDelete(scope.row)"
                    >confirmar</el-button
                  >
                </div>
                <el-tooltip
                  slot="reference"
                  content="Exclui rateios"
                  placement="bottom"
                  v-if="
                    scope.row.status === constants.status.pending ||
                    scope.row.status === constants.status.opened
                  "
                >
                  <b-icon class="icon-beaut" icon="x" font-scale="2"></b-icon>
                </el-tooltip>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="font-size: 12px" v-else>
        <el-skeleton
          :rows="3"
          animated
          v-if="!finshedLoad"
          style="width: 50%"
        />
      </div>
      <div class="right-position" v-if="openDataTable.length === 0">
        <el-button :disabled="btnIsDisable" @click="navigateUploadScreen()"
          >Importar Planilhas</el-button
        >
      </div>
      <div v-if="openDataTable.length > 0">
        <div
          class="right-position"
          v-if="openDataTable.length > 0 && closeApportionsBtn"
        >
          <el-button
            v-if="!btnIsDisable"
            :disabled="btnIsDisable"
            @click="navigateUploadScreen()"
            >Importar Planilhas</el-button
          >
          <el-button v-if="btnIsDisable" :disabled="btnIsDisable"
            >Gerar rateios</el-button
          >
        </div>
        <div
          class="right-position"
          v-if="openDataTable.length > 0 && !closeApportionsBtn"
        >
          <el-button @click="closeApportionment()" :loading="isLoadingBtnClose"
            >Concluir rateios</el-button
          >
        </div>
        <div class="right-position" v-else>
          <el-button
            v-if="btnIsDisable && !closeApportionsBtn"
            :disabled="!btnIsDisable"
            @click="navigateUploadScreen()"
            >Importar Planilhas</el-button
          >
        </div>
      </div>
    </div>
    <div class="center-home" style="margin-top: 25px">
      <p class="title_">Rateio dos meses anteriores</p>
      <div class="table-teste" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          style=""
          :header-cell-style="{ color: '#333' }"
        >
          <el-table-column label="Mês" width="100">
            <template slot-scope="scope">
              <span>{{ dayjs(scope.row.period).format("MM/YYYY") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Situação" width="120">
            <template slot-scope="scope">
              <span>{{
                scope.row.status === constants.status.closed ? "Concluido" : "-"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Data de conclusão" width="180">
            <template slot-scope="scope">
              <span>{{
                dayjs(scope.row.apportions[0].updated_at).format(
                  "DD/MM/YYYY HH:mm"
                )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Ações" width="620px">
            <template slot-scope="scope">
              <div style="display: flex">
                <a
                  class="link-download"
                  @click="exportApportionment(scope.$index, scope.row)"
                  >Exportar rateio</a
                >
                <div
                  style="
                    font-weight: bold;
                    color: rgb(0, 140, 202);
                    margin-right: 10px;
                    margin-left: 10px;
                  "
                >
                  |
                </div>
                <a
                  @click="exportLogs(scope.$index, scope.row)"
                  class="link-download"
                >
                  Exportar logs do rateio
                </a>
                <div
                  style="
                    font-weight: bold;
                    color: rgb(0, 140, 202);
                    margin-right: 10px;
                    margin-left: 10px;
                  "
                >
                  |
                </div>
                <a
                  @click="exportAvailability(scope.$index, scope.row)"
                  class="link-download"
                >
                  Exportar valores
                </a>
                <div
                  v-if="scope.$index === 0"
                  style="
                    font-weight: bold;
                    color: rgb(0, 140, 202);
                    margin-right: 10px;
                    margin-left: 10px;
                  "
                >
                  |
                </div>
                <a
                  v-if="scope.$index === 0"
                  @click="reopen(scope.row)"
                  class="link-download"
                >
                  Reabrir rateio
                </a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          :rows="3"
          animated
          v-if="!finshedLoad"
          style="width: 50%"
        />
        {{ finshedLoad ? "Sem dados para exibir." : "" }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.center-home {
  margin-left: 15%;
  margin-top: 40px;
}
</style>

<script>
import { mapActions } from "vuex";
import api from "../utils/api";
import dayjs from "../utils/dayjs";
import store from "../utils/store";
import constants from "../utils/constants";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      constants: constants,
      tableData: [],
      openDataTable: [],
      isLoadingBtnClose: false,
      isLoadingBtnRemove: false,
      dayjs: dayjs,
      visible: false,
      direction: "rtl",
      btnIsDisable: true,
      closeApportionsBtn: false,
      finshedLoad: false,
    };
  },
  async created() {
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation" ||
        e.route.match("apportionment")
      ) {
        return { ...e, disabled: false, route: "/" };
      } else {
        return { ...e, disabled: true };
      }
    });
    this.updateNavItems_(array_teste);
    this.updateNavCurrentIndex("1");
    await this.getApportionments();
    this.finshedLoad = true;
  },
  methods: {
    ...mapActions(["updateNavItems", "updateNavCurrentIndex"]),
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    cancel() {
      this.$emit("cancel");
      alert("Cancelado!");
    },
    async getApportionments() {
      this.finshedLoad = false;
      return await api
        .get("/findAllApportionments")
        .then(async (response) => {
          const { data } = response;
          let formattedData = [];

          if (data.length === 0) {
            formattedData = [
              {
                id: "123456",
                period: new Date(),
                status: constants.status.empty,
              },
            ];
            this.openDataTable = formattedData;
            this.btnIsDisable = false;
            this.closeApportionsBtn = true;
          } else {
            const groups = data.reduce((groups, apportionment) => {
              const date = apportionment.month;
              if (!groups[date]) {
                groups[date] = [];
              }
              groups[date].push(apportionment);
              return groups;
            }, {});

            let statusBtn = false;

            const groupArrays = Object.keys(groups).map((date) => {
              let apportions = groups[date];
              let status = constants.status.closed;

              if (
                apportions.some((e) => e.status === constants.status.opened)
              ) {
                status = constants.status.opened;
                statusBtn = true;
                this.closeApportionsBtn = false;
              }
              if (
                apportions.some((e) => e.status === constants.status.pending)
              ) {
                status = constants.status.pending;
                statusBtn = true;
              }

              this.closeApportionsBtn = true;
              this.btnIsDisable = statusBtn;

              apportions = apportions.sort(function (a, b) {
                return b.updated_at.localeCompare(a.updated_at);
              });

              return {
                period: new Date(date),
                generated_date: new Date(),
                status,
                apportions: groups[date],
              };
            });

            let closedArray = [];

            if (
              groupArrays.some(
                (e) =>
                  dayjs().format("MM/YYYY") ===
                  dayjs(e.period).format("MM/YYYY")
              )
            ) {
              if (statusBtn) {
                this.closeApportionsBtn = true;
              }
            } else {
              formattedData.push({
                id: "123456",
                period: dayjs(),
                status: constants.status.empty,
              });
              this.closeApportionsBtn = true;
            }

            groupArrays.map((e) => {
              if (e.status === constants.status.closed) {
                closedArray.push(e);
              } else {
                formattedData.push(e);
              }
              if (e.status === constants.status.opened) {
                this.closeApportionsBtn = false;
              }
            });

            this.tableData = closedArray;
            this.openDataTable = formattedData.map((e) => {
              return { ...e, popVisible: false };
            });

            this.finshedLoad = true;
          }
        })
        .catch(() => {
          this.finshedLoad = true;
        });
    },
    reopen(row) {
      this.isLoadingBtnClose = true;
      this.$confirm(
        `Isso se aplica a rateios de todas filiais`,
        `Deseja reabrir os rateios do mês de ${dayjs(row.period).format(
          "MM/YYYY"
        )}?`,
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: "alert-class",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Atualizando...";
              api
                .put("/reopenApportionments")
                .then(async () => {
                  const promise = this.getApportionments();
                  promise.then(() => {
                    instance.confirmButtonLoading = false;
                    done();
                    this.$message({
                      type: "success",
                      message: "Rateios foram reabertos!",
                    });
                  });
                })
                .catch(() => {
                  instance.confirmButtonLoading = false;
                  this.$message({
                    showClose: true,
                    type: "error",
                    message: "Falha ao reabrir rateios.",
                  });
                });
            } else {
              done();
            }
          },
        }
      ).finally(() => {
        this.isLoadingBtnClose = false;
      });
    },
    exportLogs(index, row) {
      api
        .get(`/exportLogs/${new Date(row.period).toISOString()}`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `LOGS-rateio-${dayjs(row.period)
              .add(3, "hours")
              .format("MM/YYYY")}.xls`
          );
          document.body.appendChild(link);
          link.click();
          this.$message({
            type: "success",
            message: "Baixado com sucesso",
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            showClose: true,
            message: "Erro ao tentar baixar planilhas.",
          });
        });
    },
    exportAvailability(index, row) {
      api
        .get(`/exportAvailability/${new Date(row.period).toISOString()}`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `LOGS-valores-${dayjs(row.period)
              .add(3, "hours")
              .format("MM/YYYY")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.$message({
            type: "success",
            message: "Baixado com sucesso",
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            showClose: true,
            message: "Erro ao tentar baixar planilha.",
          });
        });
    },
    exportApportionment(index, row) {
      api
        .get(`/exportSpreadsheets/${new Date(row.period).toISOString()}`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `rateio-${dayjs(row.period).add(3, "hours").format("MM/YYYY")}.xls`
          );
          document.body.appendChild(link);
          link.click();
          this.$message({
            type: "success",
            message: "Baixado com sucesso",
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            showClose: true,
            message: "Erro ao tentar baixar planilhas.",
          });
        });
    },
    closeApportionment() {
      this.isLoadingBtnClose = true;
      let month = [];
      this.openDataTable = this.openDataTable.sort((a, b) => {
        return a.period - b.period;
      });
      this.openDataTable.map((e) => {
        if (e.status === "OPEN") {
          month.push(e);
        }
      });
      this.$confirm(
        "Após esta ação não será mais possível editar o rateio.",
        `Alterar status do rateio de ${dayjs(month[0].period).format(
          "MM/YYYY"
        )} para concluído?`,
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: "alert-class",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Atualizando...";
              api
                .post("/closeApportionmentsByMonth", {
                  month: `${dayjs(month[0].period).toISOString()}`,
                })
                .then(async () => {
                  const promise = this.getApportionments();
                  promise.then(() => {
                    this.isLoadingBtnClose = false;
                    instance.confirmButtonLoading = false;
                    done();
                    this.$message({
                      type: "success",
                      message:
                        "Rateios foram processados e gerados com sucesso!",
                    });
                  });
                })
                .catch(() => {
                  this.isLoadingBtnClose = false;
                  instance.confirmButtonLoading = false;
                  this.$message({
                    showClose: true,
                    type: "error",
                    message: "Falha ao concluir rateios.",
                  });
                });
            } else {
              done();
            }
          },
        }
      )
        .then(() => {})
        .catch(() => {
          this.isLoadingBtnClose = false;
        });
    },
    handleDelete(row) {
      this.isLoadingBtnRemove = true;
      api
        .delete(
          `/deleteApportionmentsByMonth/${dayjs(row.period).toISOString()}`
        )
        .then(() => {
          const promise = this.getApportionments();
          promise.then(() => {
            this.isLoadingBtnRemove = false;
            this.finshedLoad = true;
            this.$message({
              type: "success",
              message: "Rateios foram removidos com sucesso!",
            });
          });
        })
        .catch(() => {
          this.isLoadingBtnRemove = false;
          this.finshedLoad = true;
          this.$message({
            showClose: true,
            type: "error",
            message: "Não foi possível remover os rateios.",
          });
        });
    },
    navigateUploadScreen() {
      this.$router.push({ name: "upload" });
    },
  },
};
</script>
